import {
    IoCContainer
} from '@lmnop/web-core';
import {
    AppIoCKeys, IAppSettings
} from 'app-src';
import {
    IAppIoCContainer
} from './app-ioc-container.interface';
import {
    CoreModulesIoC
} from './core-modules-ioc.class';

export class AppIoCContainer implements IAppIoCContainer {

    public lateBindIoC(): void {
        this.core = new CoreModulesIoC();
        this.settings = IoCContainer.get(AppIoCKeys.IAppSettings);
    }

    public core: CoreModulesIoC;
    public settings: IAppSettings;

}
